//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from '~/components/Shared/Button.vue'
import AutoSaving from '~/components/Validation/AutoSaving.vue'
import checkIsMobileMixin from '~/mixins/checkIsMobileMixin.js'
export default {
  components: {
    Button,
    AutoSaving,
  },
  mixins: [checkIsMobileMixin],
  props: {
    saving: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handleClick() {
      this.$emit('click')
    },
    handleClickSeeCollaborators() {
      this.$emit('click-see-collaborators')
    },
  },
}
